import React, { useCallback, useEffect, useState } from "react";
import { TextField } from "@mui/material";
import Cached from "@mui/icons-material/Cached";
import SwapHorizOutlined from "@mui/icons-material/SwapHorizOutlined";
import moment from "moment";
import { Buttons, HeaderButton } from "components";
import XGrid from "components/UI/Grid/XGrid";
import { habitacionHuespedesTitles as titles } from "consts/titulos-de-tablas";
import modalStyles from "styles/pages/ModalActions.module.scss";
import { useRecoilValue } from "recoil";
import { ACTIONS } from "consts/Actions";
import { userCredentials } from "recoilState/GlobalState";
import { SFHotelUsuarioGet } from "services/services-mia/SFHotelUsuarioGet";
import { mapHotelUsuarioList } from "pages/hoteles/utils/mapHotelUsuario";
import { isCambioHabitacionDisponible } from "pages/hoteles/utils/reservaActions";
import { VisibilityOutlined } from "@mui/icons-material";
import Modal from "components/UI/Modal/Modal";
import DetallesHuesped from "../../detallesHuesped/DetallesHuesped";
import CambioHabitacionModal from "../../reservas/Actions/CambioHabitacionModal";

export default function DetailModal({ habitacion, onUpdate }) {
    const credentials = useRecoilValue(userCredentials);
    const [fecha, setFecha] = useState(moment().format("YYYY-MM-DD"));
    const [huespedes, setHuespedes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [rowSelected, setRowSelected] = useState({ status: false, row: {} });
    const [modalDetails, setModalDetails] = useState({ isOpen: false });

    const loadHuespedes = useCallback(async () => {
        if (!habitacion?.id || !fecha) return;
        setLoading(true);
        setHuespedes([]);
        const result = await SFHotelUsuarioGet(credentials, {
            SFHabitacionId: habitacion.id,
            fecha,
        });
        setHuespedes(mapHotelUsuarioList(result));
        setLoading(false);
    }, [credentials, habitacion?.id, fecha]);

    useEffect(() => {
        loadHuespedes();
    }, [loadHuespedes]);

    const handleActionSuccess = () => {
        loadHuespedes();
        onUpdate?.();
    };

    const handleClick = ({ procede, title }) => {
        setModalDetails({ procede, title, isOpen: true });
    };

    const closeModal = () => setModalDetails({ isOpen: false });

    return (
        <div className={modalStyles["detail-modal"]} >
            <Modal
                compact={modalDetails.procede !== ACTIONS.DETAIL}
                wide={modalDetails.procede === ACTIONS.DETAIL}
                open={modalDetails.isOpen}
                title={modalDetails.title}
                onClose={closeModal}

            >
                {modalDetails.procede === ACTIONS.DETAIL && (
                    <DetallesHuesped huesped={rowSelected.row} />
                )}
                {modalDetails.procede === ACTIONS.UPDATE && (
                    <CambioHabitacionModal
                        reserva={rowSelected.row}
                        hotelId={habitacion?.hotelId}
                        updateList={handleActionSuccess}
                        closeModal={closeModal}
                        setterRowSelected={setRowSelected}
                    />
                )}
            </Modal>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "1rem 1rem 0" }}>
                <TextField
                    label="Fecha"
                    type="date"
                    variant="standard"
                    value={fecha}
                    onChange={(e) => setFecha(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    sx={{ minWidth: 180 }}
                />
                <Buttons>
                    <HeaderButton text="Actualizar" onClick={loadHuespedes}>
                        <Cached />
                    </HeaderButton>
                    <HeaderButton
                        text="Detalle del Huesped"
                        handleClick={handleClick}
                        data={{
                            title: `Detalles del huésped`,
                            procede: ACTIONS.DETAIL,
                        }}
                        disabled={!rowSelected.row.id}
                    >
                        <VisibilityOutlined />
                    </HeaderButton>
                    <HeaderButton
                        text="Cambiar habitación"
                        handleClick={handleClick}
                        data={{
                            title: `Cambiar habitación - Hab. ${habitacion?.numero ?? ""}`,
                            procede: ACTIONS.UPDATE,
                        }}
                        disabled={!isCambioHabitacionDisponible(rowSelected.row)}
                    >
                        <SwapHorizOutlined />
                    </HeaderButton>
                </Buttons>
            </div>

            <div className={modalStyles["detail-grid"]}>
                <XGrid
                    rows={huespedes}
                    titles={titles}
                    loading={loading}
                    fillHeight
                    secondarySelected={rowSelected}
                    setSecondarySelected={setRowSelected} />
            </div>
        </div>
    );
}
